module.exports = __webpack_public_path__ + "img/40_38_049_140.5aa29787.jpg";